<section class="vm-row vm-media-tiles-section center" [id]="data?.id" [class.prototype]="isPrototype">
  <div *ngIf="data?.title" class="vm-col-sm-12">
    <h2>
      {{ data?.title }}
    </h2>
  </div>
  <vm-markdown *ngIf="data?.copy" [data]="data?.copy" class="vm-col-sm-12"></vm-markdown>
  <div
    [id]="item?.id"
    *ngFor="let item of data?.items"
    [ngClass]="
      data?.items?.length % 3 === 0
        ? 'vm-col-xs-12 vm-col-md-6 vm-col-lg-4'
        : data?.items?.length % 2 === 0
        ? 'vm-col-xs-12 vm-col-md-6'
        : 'vm-col-xs-12 vm-col-sm-6'
    ">
    <div
      class="bdr"
      [ngClass]="data.hasItemSubTitles === true ? 'sub-title-padding' : ''"
      [class.no-pad-top]="!item?.title && !item?.subTitle">
      <span *ngIf="item?.subTitle" class="sub-title bgGreen">{{ item?.subTitle }}</span>
      <div *ngIf="item?.title" class="vm-row">
        <h3>{{ item?.title }}</h3>
      </div>
      <vm-markdown *ngIf="item?.copy" [data]="item?.copy"></vm-markdown>
      <div class="vm-row">
        <vm-media
          *ngIf="item?.iconSrc"
          [source]="item?.iconSrc | mediaSrcStrapi: strapiUrl"
          [altText]="item?.alt || item?.title"></vm-media>
      </div>
    </div>
  </div>
</section>
